export default {
    props: {
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        forceLabel: {
            type: [String, Boolean],
            required: false,
            default: false,
        },
        value: {
            type: String,
            required: true,
        },
        canRemoveFavorite: {
            type: Boolean,
            required: false,
            default: false,
        },
        isCurrency: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        canRemoveFavoriteClass() {
            return this.canRemoveFavorite ? 'ellipsis' : '';
        },
    },
};
